import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import getCookieByName from '../../helpers/get-cookie-by-name';
import { AmplitudeContext } from '../amplitude-context';
const useAmplitudeCookies = () => {
  const $ = _c(6);
  const instance = useContext(AmplitudeContext)?.instance ?? null;
  const [amplitudeSessionId, setAmplitudeSessionId] = useState(null);
  const [amplitudeDeviceId, setAmplitudeDeviceId] = useState(null);
  let t0;
  let t1;
  if ($[0] !== instance) {
    t0 = () => {
      if (!instance) {
        return;
      }
      let isActive = true;
      instance.initialized.then(() => {
        if (!isActive) {
          return;
        }
        const currentDeviceId = instance.client.getDeviceId();
        const currentSessionId = instance.client.getSessionId();
        if (currentDeviceId && getCookieByName("amplitudeDeviceId") !== currentDeviceId) {
          document.cookie = `amplitudeDeviceId=${currentDeviceId}; path=/;`;
        }
        if (currentSessionId && Number(getCookieByName("amplitudeSessionId")) !== currentSessionId) {
          document.cookie = `amplitudeSessionId=${currentSessionId}; path=/;`;
        }
        setAmplitudeDeviceId(currentDeviceId ?? null);
        setAmplitudeSessionId(currentSessionId ? currentSessionId.toString() : null);
      });
      return () => {
        isActive = false;
      };
    };
    t1 = [instance];
    $[0] = instance;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== amplitudeDeviceId || $[4] !== amplitudeSessionId) {
    t2 = {
      deviceId: amplitudeDeviceId,
      sessionId: amplitudeSessionId
    };
    $[3] = amplitudeDeviceId;
    $[4] = amplitudeSessionId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default useAmplitudeCookies;